import { TemplateType } from "@nocios/presentation-kit";

import DATA_BASE_0 from "./0DATA_BASE";
import DATA_BASE_1 from "./1DATA_BASE";
import DATA_BASE_2 from "./2DATA_BASE";
import DATA_BASE_3 from "./3DATA_BASE";
import DATA_BASE_4 from "./4DATA_BASE";
import DATA_BASE_5 from "./5DATA_BASE";
import DATA_BASE_6 from "./6DATA_BASE";
import DATA_BASE_7 from "./7DATA_BASE";
import DATA_BASE_8 from "./8DATA_BASE";
import DATA_BASE_9 from "./9DATA_BASE";
import DATA_BASE_10 from "./10DATA_BASE";

const DEMO_WORKFLOW = [
  { page: 0, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_0 },
  { page: 1, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_1 },
  { page: 2, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_2 },
  { page: 3, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_3 },
  { page: 4, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_4 },
  { page: 5, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_5 },
  { page: 6, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_6 },
  { page: 7, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_7 },
  { page: 8, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_8 },
  { page: 9, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_9 },
  { page: 10, type: "base-template" as TemplateType, dataTemplate: DATA_BASE_10 },
];

export default DEMO_WORKFLOW;
